// Imagen por defecto del furgón hero (CDN Readdy)
export const HERO_IMAGE_DEFAULT =
  "https://storage.readdy-site.link/project_files/cf1847c3-949c-4dd2-b2c0-64bc50d47abe/75e02df2-baaa-4ae7-b9c3-b341fbe660c4_Persianas-Toldos-Mlaga.jpg?v=d52c78f188bb6ff8700ddfa33a25b253";